import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { renderDynamicUrlFromState } from "../../../../helpers/utils/urlHelper";
import axiosInstance from "../../../../apiConfigs/axiosInstance";
import { REQUIRED__TOASTER } from "../../../../helpers/utils/TosterError";

export const loadCoursePrice = createAsyncThunk(
  "loadCoursePrice",
  async ({type}:{type:string}, { dispatch, rejectWithValue, getState }) => {
    try {
      const state = getState();
      const dynamic_url = renderDynamicUrlFromState(state);

      const res = await axiosInstance.get(
        `${dynamic_url}/certified-course-pricing?type=${type}`
      );
      return res.data;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const addorUpdatecoursePrice = createAsyncThunk(
  "addorUpdatecoursePrice",
  async ({ data }: { data: any }, { dispatch, rejectWithValue, getState }) => {
    try {
      const state = getState();
      const dynamic_url = renderDynamicUrlFromState(state);
      const res = await axiosInstance.post(
        `${dynamic_url}/certified-course-pricing/${data.id}`,
        data
      );
      // REQUIRED__TOASTER(res.data)
      if (res.data.success) {
        toast.success("Price updated successfully.");
      }

      return res.data;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const addorUpdatePagecoursePrice = createAsyncThunk(
  "addorUpdatePagecoursePrice",
  async ({ data }: { data: any }, { dispatch, rejectWithValue, getState }) => {
    try {
      const state = getState();
      const dynamic_url = renderDynamicUrlFromState(state);
      const res = await axiosInstance.post(
        `${dynamic_url}/certified-course-pricing/${data.id}`,
        data
      );
      // REQUIRED__TOASTER(res.data)
      if (res.data.success) {
        if(data?.id){
          toast.success("Price updated successfully.");
        }else{
          toast.success("Price added successfully.");
        }
      }

      return res.data;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);
export const deletePagecoursePrice = createAsyncThunk(
  "deletePagecoursePrice",
  async ({ id }: { id: any }, { dispatch, rejectWithValue, getState }) => {
    try {
      const state = getState();
      const dynamic_url = renderDynamicUrlFromState(state);
      const res = await axiosInstance.delete(
        `${dynamic_url}/certified-course-pricing/${id}`
      );

      if (res.data.success) {
        toast.success("Price deleted successfully.");
      }

      return res.data;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);
